import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { Redirect } from 'react-router'

import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import Layout from '../../../../components/ui/Layout/Layout'
// import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import Avatar from '../../../../components/ui/Avatar/Avatar'
import PreferenceForm from '../../../../components/home/PreferenceForm/PreferenceForm'
import confetti from '../../../../assets/img/confetti.png'

import validatePreferences from '../../../../services/validation/Preference'
import {
  setGAEvent,
  setGAPageView,
} from '../../../../services/analytics/google-analytics'
import {
  LANDING,
  PREFERENCES,
} from '../../../../services/data/registrationSteps.json'
import media from '../../../../services/generateMediaQueries'
import { postDevices } from '../../../../services/api/requests/Device'

const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  margin: 0;
  margin-bottom: 0.8125rem;
  color: var(--color-secondary);
  font-weight: var(--font-weight-boldest);
`

const StyledAvatar = styled(Avatar)`
  width: 7.5rem;
  height: 7.5rem;
`

const AvatarWrapper = styled.div`
  padding: 3.75rem 0 3.4375rem;
  text-align: center;
  color: var(--color-primary);
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: center;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${confetti});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12.5rem;
  }
`

const FormWrapper = styled.div`
  margin: 0;
  margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? 0 : '1rem')};
  ${media.lessThan('small')`
    margin: 0.5rem 0;
    margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? 0 : '0.5rem')};
  `};
`

const dropOffEvent = () => {
  setGAEvent('sign_up', 'sign_up_drop_off', 'registration_preferences')
}

function MainView({
  push,
  step,
  browser,
  setDevice,
  accessToken,
  primaryInfo,
  location = {},
  setPreferences,
  basePreferences,
  saveAccessToken,
  doGetPreferences,
  setPreferenceIds,
  redirectAfterAuth,
  doSubmitPreferences,
}) {
  React.useEffect(() => {
    if (location) setGAPageView(location.pathname)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  React.useEffect(() => {
    window.addEventListener('beforeunload', dropOffEvent)

    return () => {
      window.removeEventListener('beforeunload', dropOffEvent)
    }
  }, [])

  React.useEffect(() => {
    doGetPreferences({
      setPreferences,
    })()
  }, [doGetPreferences, setPreferences])

  React.useEffect(() => {
    if (window.document.cookie.includes('web_uuid=')) {
      return
    }
    const { name, os, version } = browser
    postDevices({
      platform: 'web',
      deviceName: name,
      deviceModel: os,
      osVersion: version,
    }).then(res => {
      setDevice(res.data)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const redirectToDashboard = () => {
  //   saveAccessToken(accessToken)
  //   push(redirectAfterAuth || '/')
  // }

  if (step !== PREFERENCES) {
    return <Redirect to="/register" />
  }

  if (primaryInfo === null) {
    return null
  }

  const { avatarUrl } = primaryInfo || {}

  return (
    <Layout>
      <AvatarWrapper>
        <StyledAvatar src={avatarUrl} />
      </AvatarWrapper>
      <Title>Awaken Amazing!</Title>
      <FormWrapper noMarginBottom>
        {basePreferences && (
          <AccessibleForm
            validate={validatePreferences}
            initialValues={{}}
            onSubmit={doSubmitPreferences({
              push,
              accessToken,
              saveAccessToken,
              setPreferenceIds,
              redirectAfterAuth,
            })}
            component={PreferenceForm}
            action="/a/register/preferences"
            componentProps={{ basePreferences }}
          />
        )}
      </FormWrapper>
      {/* <BlockButton onClick={redirectToDashboard}>Skip Preferences</BlockButton> */}
    </Layout>
  )
}

MainView.defaultProps = {
  redirectAfterAuth: '',
  primaryInfo: null,
  step: LANDING,
}

MainView.propTypes = {
  accessToken: PropTypes.string.isRequired,
  redirectAfterAuth: PropTypes.string,
  step: PropTypes.number,
  primaryInfo: PropTypes.shape(),
  basePreferences: PropTypes.shape(),
  setPreferences: PropTypes.func.isRequired,
  saveAccessToken: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  doGetPreferences: PropTypes.func.isRequired,
  doSubmitPreferences: PropTypes.func.isRequired,
}

export default MainView
